import actionTypes from "./actionTypes";
import * as mapaUtils from "../utils/mapaUtils";

export const changeExtentCoords = (extent, coords) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_MAPA_EXTENT_COORDS,
      res: { extent: extent, coords: coords },
    });
  };
};
export const changeImage = (image) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_MAPA_IMAGE,
      res: { image },
    });
  };
};

const getURLRequest = () => ({
  type: actionTypes.GET_MAPA_URL_REQUEST,
});
const getURLSuccess = (res) => ({
  type: actionTypes.GET_MAPA_URL_SUCCESS,
  res,
});
const getURLFailure = (error) => ({
  type: actionTypes.GET_MAPA_URL_FAILURE,
  error,
});
export const getURL = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getURLRequest());
      let res = await mapaUtils.getURL(data);
      dispatch(getURLSuccess(res));
    } catch (error) {
      dispatch(getURLFailure(error));
    }
  };
};
export const getURLBasedOnLatLng = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getURLRequest());
      let res = await mapaUtils.getURLBasedOnLatLng(data);
      dispatch(getURLSuccess(res));
    } catch (error) {
      dispatch(getURLFailure(error));
    }
  };
};

const getLatLngFromGoogleMapRequest = () => ({
  type: actionTypes.GET_GOOGLE_MAP_LAT_LNG_REQUEST,
});
const getLatLngFromGoogleMapSuccess = (res) => ({
  type: actionTypes.GET_GOOGLE_MAP_LAT_LNG_SUCCESS,
  res,
});
const getLatLngFromGoogleMapFailure = (error) => ({
  type: actionTypes.GET_GOOGLE_MAP_LAT_LNG_FAILURE,
  error,
});
export const getLatLngFromGoogleMap = (address) => {
  return async (dispatch) => {
    try {
      dispatch(getLatLngFromGoogleMapRequest());
      let res = await mapaUtils.getLatLngFromGoogleMap(address);
      dispatch(getLatLngFromGoogleMapSuccess(res));
    } catch (error) {
      dispatch(getLatLngFromGoogleMapFailure(error));
    }
  };
};

const getMapaExtentCoordsRequest = () => ({
  type: actionTypes.GET_MAPA_EXTENT_COORDS_REQUEST,
});
const getMapaExtentCoordsSuccess = (res) => ({
  type: actionTypes.GET_MAPA_EXTENT_COORDS_SUCCESS,
  res,
});
const getMapaExtentCoordsFailure = (error) => ({
  type: actionTypes.GET_MAPA_EXTENT_COORDS_FAILURE,
  error,
});
export const getMapaExtentCoords = () => {
  return async (dispatch) => {
    try {
      dispatch(getMapaExtentCoordsRequest());
      let res = await mapaUtils.getExtentCoords();
      dispatch(getMapaExtentCoordsSuccess(res));
    } catch (error) {
      dispatch(getMapaExtentCoordsFailure(error));
    }
  };
};

const getMapaImageRequest = () => ({
  type: actionTypes.GET_MAPA_IMAGE_REQUEST,
});
const getMapaImageSuccess = (res) => ({
  type: actionTypes.GET_MAPA_IMAGE_SUCCESS,
  res,
});
const getMapaImageFailure = (error) => ({
  type: actionTypes.GET_MAPA_IMAGE_FAILURE,
  error,
});
export const getMapaImage = () => {
  return async (dispatch) => {
    try {
      dispatch(getMapaImageRequest());
      let res = await mapaUtils.getImage();
      dispatch(getMapaImageSuccess(res));
    } catch (error) {
      dispatch(getMapaImageFailure(error));
    }
  };
};
